import React from 'react';
import Link from 'next/link';
import styles from '../../../../styles/sass/components/RecommendedListings.module.scss';
import {
  formatUrlAddress,
  normalizePriceWithPrefix,
} from '../../../../lib/helpers';

interface Props {
  listing: any;
}

const style = {
  imgStyle: {
    height: '100%',
    width: '100%',
    borderRadius: '30px',
  },
  linkStyle: {
    textDecoration: 'none',
    color: '#323232',
    boxShadow: '0px 4px 16px 0px #00000029',
    borderRadius: 15,
  },
  priceFont: {
    fontSize: 16,
    fontWeight: 600,
  },
};
const renderListings = (listing: any) => {
  return (
    <Link
      href={`/listing/r/${listing.listingMlsId}/${formatUrlAddress(listing)}`}
    >
      <div className={styles.listingContainer}>
        <div className={styles.imageBox}>
          <img className={styles.imageStyle} src={listing.photoMedium} />
        </div>
        <div className={styles.infoBox}>
          <h2 className={styles.price}>
            {normalizePriceWithPrefix(`${listing.listPrice}`)}
          </h2>
          <p className={styles.listingDetails}>
            {`${listing.noBedrooms} br, ${listing.noFullBaths} ba, ${listing.squareFeet} sq ft`}
            <br />
            {`${listing.address}`}
          </p>
        </div>
      </div>
    </Link>
  );
};

const Listing = ({ listing }: Props) => {
  return renderListings(listing);
};

export const MobileListing = ({ listing }: Props) => {
  return <div>{renderListings(listing)}</div>;
};

export default Listing;
